<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="transportationTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
<!--        <template slot="companyId" slot-scope="data">-->
<!--          <span>{{data.row.companyId | FILTER_Company}}</span>-->
<!--        </template>-->
        <template slot="imgJson" slot-scope="data" v-if="data.row.imgJson !== ''">
          <img class="table-img" v-for="(item, index) in JSON.parse(data.row.imgJson).imageUrl" :src="item" :key="index">
        </template>
        <template slot="status" slot-scope="data">
          <el-tag type="success" v-if="data.row.status === 10">清运完成</el-tag>
          <el-tag type="danger" v-else-if="data.row.status === 5">清运中</el-tag>
          <el-tag type="success" v-else-if="data.row.status === 8">等待清运</el-tag>
          <el-tag v-else-if="data.row.status === 1">正常</el-tag>
          <el-tag v-else-if="data.row.status === 2">关闭</el-tag>
          <el-tag v-else-if="data.row.status === 3">到期</el-tag>
          <el-tag v-else-if="data.row.status === 4">维护</el-tag>
          <el-tag v-else-if="data.row.status === 7">系统核查</el-tag>
          <el-tag v-else-if="data.row.status === 9">已发放</el-tag>
          <el-tag v-else-if="data.row.status === 11">违规投递</el-tag>
          <el-tag v-else-if="data.row.status === 12">部分违规投递</el-tag>
          <el-tag type="danger" v-else>系统核查中</el-tag>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>

</template>

<script>

export default {
  name: 'TransportationList',
  isAutoComponent: true,
  mounted() {
    // 从路由参数中获取userid
    this.setUseridFromRoute()
  },
  watch: {
    '$route.query.userid': function(newVal) {
      if (newVal) {
        this.setUseridFromRoute()
      }
    },
    '$route.query.sn': function(newVal) {
      if (newVal) {
        this.setUseridFromRoute()
      }
    }
  },
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_TRANSPORTATION_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablHardwareClearLog/dataList' }
        },
        formInputsData: [
          { name: '箱体名称', key: 'boxName', value: '', type: 'text' },
          { name: 'SN', key: 'sn', value: this.$route.query.sn || '', type: 'text' },
          { name: 'userid', key: 'userId', value: this.$route.query.userid || '', type: 'text' },
          { name: '状态',
            key: 'status',
            value: '',
            type: 'select',
            data: [
              { label: '已发放', value: '10' },
              { label: '清运中', value: '5' },
              { label: '未处理', value: '7' }
            ] }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          url: window.wtConst.BASE_API + '/modules/ablHardwareClearLog/exportExcel',
          fileName: '清运记录',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '公司名称', key: 'companyName' },
          { name: '箱体名称', key: 'boxName', type: 'text' },
          { name: '地址', key: 'addr', type: 'text' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: '违投图片', key: 'imgJson', type: 'custom' },
          { name: '清运金额(元)', key: 'totalPrice', type: 'text' },
          { name: '重量(Kg)', key: 'weight', type: 'text' },
          { name: '清运员', key: 'clearUserName', type: 'text' },
          { name: '清运时间', key: 'endClearTime', type: 'text' },
          { name: '状态', key: 'status', type: 'custom' },
          { name: '违投原因', key: '', type: 'text' },
          { name: '创建时间', key: 'createdAt', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    },
    setUseridFromRoute() {
      const userid = this.$route.query.userid
      const sn = this.$route.query.sn
      if (userid) {
        // 更新userid值
        this.form.formInputsData.forEach((item, index) => {
          if (item.key === 'userid') {
            this.$set(this.form.formInputsData[index], 'value', userid)
          }
        })
        // 触发查询
        setTimeout(() => {
          this.$refs.transportationTableRef && this.$refs.transportationTableRef.doQuery()
        }, 200)
      }
      if (sn) {
        // 更新sn值
        this.form.formInputsData.forEach((item, index) => {
          if (item.key === 'sn') {
            this.$set(this.form.formInputsData[index], 'value', sn)
          }
        })
        // 触发查询
        setTimeout(() => {
          this.$refs.transportationTableRef && this.$refs.transportationTableRef.doQuery()
        }, 200)
      }
    }
  }
}
</script>
